export const BAREKA_TAB_INDEX = '0';
export const REKENSPRINT_TAB_INDEX = '1';
export const ATR_TAB_INDEX = '2';

export const POPUP_DEFAULTS = {
    WIDTH: '807px',
    HEIGHT: 'auto',
  };
